import type { DayAvailability, TimeRange } from '../types/plan';

export function timeToMinutes(value: string) {
  const match = /^(?:[01]\d|2[0-3]):[0-5]\d$/.exec(value);
  if (!match) return 0;
  const [hours, minutes] = value.split(':').map(Number);
  return hours * 60 + minutes;
}

export function minutesToTime(total: number) {
  const safe = Math.max(0, Math.round(total));
  return `${String(Math.floor(safe / 60) % 24).padStart(2, '0')}:${String(safe % 60).padStart(2, '0')}`;
}

export function rangeGrossMinutes(range: TimeRange) {
  return Math.max(0, timeToMinutes(range.end) - timeToMinutes(range.start));
}

export function rangeNetMinutes(range: TimeRange) {
  return Math.max(0, rangeGrossMinutes(range) - Math.max(0, Number(range.breakMinutes || 0)));
}

export function availabilityMinutes(days: DayAvailability[]) {
  return days.reduce((sum, day) => sum + (day.enabled ? day.ranges.reduce((rangeSum, range) => rangeSum + rangeNetMinutes(range), 0) : 0), 0);
}

export function validateDayAvailability(day: DayAvailability) {
  const errors: string[] = [];
  if (!day.enabled) return errors;
  const ranges = [...day.ranges].sort((first, second) => timeToMinutes(first.start) - timeToMinutes(second.start));
  ranges.forEach((range, index) => {
    if (!/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(range.start) || !/^(?:[01]\d|2[0-3]):[0-5]\d$/.test(range.end)) {
      errors.push('Informe os horários no formato HH:MM.');
      return;
    }
    const start = timeToMinutes(range.start);
    const end = timeToMinutes(range.end);
    if (end <= start) errors.push('O horário final deve ser posterior ao inicial.');
    if (Number(range.breakMinutes || 0) >= end - start) errors.push('O intervalo deve ser menor que a faixa disponível.');
    if (index > 0 && start < timeToMinutes(ranges[index - 1].end)) errors.push('As faixas de horário do mesmo dia não podem se sobrepor.');
  });
  return [...new Set(errors)];
}

export function formatMinutes(total: number) {
  const minutes = Math.max(0, Math.round(total));
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  if (!hours) return `${rest}min`;
  return rest ? `${hours}h${String(rest).padStart(2, '0')}` : `${hours}h`;
}
